/** Perfis canônicos na matriz: admin, encarregado, secretario, instrutor */
export const USER_ROLES = ['admin', 'encarregado', 'secretario', 'instrutor'];

/** Alias → perfil canônico (sem alterar dados no banco). */
export const normalizeUserRole = (tipo) => {
  if (tipo === 'secretaria') return 'secretario';
  if (tipo === 'superadmin') return 'admin';
  return tipo;
};

const normalizeRole = normalizeUserRole;

export const CAPABILITY_MATRIX = {
  'dashboard.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'alunos.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'alunos.manage': ['admin', 'encarregado', 'secretario'],
  'carteirinha.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'carteirinha.manage': ['admin', 'encarregado', 'secretario'],
  'presencas.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'presencas.manage': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'presencas.apply_manual_absences': ['admin', 'encarregado', 'secretario'],
  'progresso.edit': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'usuarios.manage': ['admin', 'encarregado', 'secretario'],
  'instrutores.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'instrutores.manage': ['admin', 'encarregado', 'secretario'],
  'instrutores.presencas.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'instrutores.presencas.manage': ['admin', 'encarregado', 'secretario'],
  'instrutores.relatorios.view': ['admin', 'encarregado', 'secretario'],
  'instrutores.configuracoes.manage': ['admin', 'encarregado', 'secretario'],
  'configuracoes.dias_gem.manage': ['admin', 'encarregado', 'secretario'],
  'configuracoes.horario_falta.manage': ['encarregado', 'secretario'],
  'configuracoes.integracoes.manage': ['admin', 'encarregado', 'secretario'],
  'configuracoes.aptidao.manage': ['admin', 'encarregado', 'secretario'],
  'alertas.sistema.view': ['admin'],
  'alertas.aptidao.view': ['admin', 'encarregado', 'secretario'],
  'alertas.whatsapp.view': ['encarregado', 'secretario'],
  'observabilidade.view': ['admin'],
  'auditoria.view': ['admin'],
  'backup.manage': ['admin'],
  'admin.view': ['admin'],
  'relatorios.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'fichas.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'fichas.templates.manage': ['admin', 'encarregado', 'secretario'],
  'metas_pedagogicas.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'metas_pedagogicas.manage': ['admin', 'encarregado', 'secretario'],
  'acompanhamentos.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'acompanhamentos.manage': ['admin', 'encarregado', 'secretario'],
  'acompanhamentos.registrar_acao': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'alertas_pedagogicos.view': ['admin', 'encarregado', 'secretario', 'instrutor'],
  'alertas_pedagogicos.manage': ['admin', 'encarregado', 'secretario'],
  'alertas_pedagogicos.enviar_externo': ['admin', 'encarregado']
};

export const hasPermission = (userOrTipo, capability) => {
  const tipoBruto = typeof userOrTipo === 'string' ? userOrTipo : userOrTipo?.tipo;
  const tipo = normalizeRole(tipoBruto);
  const allowed = CAPABILITY_MATRIX[capability];
  if (!tipo || !allowed) return false;
  return allowed.includes(tipo);
};

export const canAccessRoute = (user, requiredPermission) => {
  if (!requiredPermission) return Boolean(user);
  return hasPermission(user, requiredPermission);
};
